import { Controller } from '@hotwired/stimulus';
import Cookies from 'js-cookie';

export default class extends Controller {
  static values = {
    timeZone: String,
  };

  connect() {
    if (!this.timeZoneValue) return;
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (userTimeZone !== this.timeZoneValue) {
      this.element.classList.remove('hidden');
      if (Cookies.get('time-zone-warning')) {
        return;
      }
      Cookies.set('time-zone-warning', '1', { expires: 7 });
    } else {
      this.element.classList.add('hidden');
      Cookies.remove('time-zone-warning');
    }
  }
}
